import { render, staticRenderFns } from "./EnableTwoFa.vue?vue&type=template&id=b1c903da&scoped=true"
import script from "./EnableTwoFa.vue?vue&type=script&lang=js"
export * from "./EnableTwoFa.vue?vue&type=script&lang=js"
import style0 from "./EnableTwoFa.vue?vue&type=style&index=0&id=b1c903da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c903da",
  null
  
)

export default component.exports